import jsPDF from "jspdf";
import logo from "../../assets/logo.png";
import { calculateOfficeSchemeFee } from "./gstCalculator";

function inr(n) {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);
}

export function generateOfficeProposalPDF({ form, designResult, estimate }) {
  const fee = calculateOfficeSchemeFee(estimate?.estimateAmount || 0);

  const doc = new jsPDF("p", "mm", "a4");
  const navy = [21, 38, 73];

  doc.setDrawColor(...navy);
  doc.setLineWidth(0.8);
  doc.rect(10, 10, 190, 277);

  doc.addImage(logo, "PNG", 16, 16, 24, 24);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text("SHINE AGRI ALLIED AND MARKETING MSCS LTD.", 45, 24);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  doc.text("Office Design, Estimate & Subsidy Facilitation Proposal", 45, 32);
  doc.text("GSTIN: 24ACNAS4114R1ZV | PAN: ACNAS4114R", 45, 39);

  doc.setFillColor(...navy);
  doc.rect(10, 48, 190, 12, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text("OFFICE SCHEME PROPOSAL", 105, 56, { align: "center" });

  doc.setTextColor(0, 0, 0);

  let y = 72;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("1. Society / PACS Details", 16, y);

  y += 9;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`Society Name: ${form.societyName || "-"}`, 16, y);
  y += 7;
  doc.text(`Registration No: ${form.registrationNo || "-"}`, 16, y);
  y += 7;
  doc.text(`Address: ${form.address || "-"}`, 16, y, { maxWidth: 175 });
  y += 7;
  doc.text(
    `Village: ${form.village || "-"}   Taluka: ${form.taluka || "-"}   District: ${form.district || "-"}`,
    16,
    y
  );
  y += 7;
  doc.text(`Mobile: ${form.mobile || "-"}   Email: ${form.email || "-"}`, 16, y);

  y += 14;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("2. Plot & Design Selection", 16, y);

  y += 9;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    `Plot Measurement: East ${form.east || 0} ft, West ${form.west || 0} ft, North ${form.north || 0} ft, South ${form.south || 0} ft`,
    16,
    y
  );

  y += 7;
  doc.text(`Office Front Side: ${form.frontSide || "-"}`, 16, y);

  y += 7;
  doc.text(`Calculated Plot Area: ${designResult?.plotArea || 0} Sq.ft`, 16, y);

  y += 7;
  doc.setFont("helvetica", "bold");
  doc.text(
    `Auto Selected Design: ${designResult?.selectedDesign?.title || "-"} (${designResult?.selectedDesign?.sizeLabel || "-"})`,
    16,
    y
  );

  y += 14;
  doc.setFontSize(11);
  doc.text("3. Estimate & Payment Calculation", 16, y);

  y += 8;
  drawRow(doc, "Total Estimate Cost", `Rs. ${inr(fee.totalEstimate)}`, y);
  y += 8;
  drawRow(doc, "Consultancy Fee @ 1.5%", `Rs. ${inr(fee.consultancyFee)}`, y);
  y += 8;
  drawRow(doc, "CGST @ 9%", `Rs. ${inr(fee.cgst)}`, y);
  y += 8;
  drawRow(doc, "SGST @ 9%", `Rs. ${inr(fee.sgst)}`, y);

  y += 2;
  doc.line(16, y, 194, y);

  y += 8;
  doc.setFont("helvetica", "bold");
  drawRow(doc, "Total Payable", `Rs. ${inr(fee.grandTotal)}`, y);

  y += 16;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("4. Services Included", 16, y);

  const services = [
    "Architectural office design as per selected model",
    "District-wise pre-approved estimate reference",
    "PACS/Society name overlay on estimate document",
    "R&B verification coordination support",
    "Engineer stage-wise completion certificate support",
    "CA utilization certificate coordination support",
    "District Registrar / subsidy process documentation support",
    "Online tracking dashboard and document record",
  ];

  y += 8;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  services.forEach((s) => {
    doc.text(`• ${s}`, 18, y);
    y += 6;
  });

  y += 8;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("5. Payment Terms", 16, y);

  y += 8;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    "The applicable consultancy/service fee shall be 1.5% of total estimate cost plus GST @18%. Payment shall be made through RTGS/NEFT/Bank Transfer after application submission and before release of final documents.",
    16,
    y,
    { maxWidth: 178 }
  );

  y += 18;
  doc.setFont("helvetica", "bold");
  doc.text("Bank Details:", 16, y);

  y += 7;
  doc.setFont("helvetica", "normal");
  doc.text("Bank Name: INDUSIND BANK", 16, y);
  y += 6;
  doc.text("A/C No: 201035786608", 16, y);
  y += 6;
  doc.text("IFSC: INDB0002348", 16, y);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("For Shine Agri Allied and Marketing MSCS Ltd.", 110, 265);
  doc.text("Authorized Signatory", 145, 277);

  doc.save(`Office_Proposal_${form.societyName || "PACS"}.pdf`);
}

function drawRow(doc, label, value, y) {
  doc.setFontSize(9);
  doc.text(label, 18, y);
  doc.text(value, 190, y, { align: "right" });
}